import React, { useEffect, useState } from 'react'
import { Button, Input, Modal, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

const { Text } = Typography
const { TextArea } = Input

interface ReconciliationApproveModalProps {
  open: boolean
  count: number
  loading?: boolean
  onCancel: () => void
  onConfirm: (comment: string) => void
}

const ReconciliationApproveModal: React.FC<ReconciliationApproveModalProps> = ({
  open,
  count,
  loading,
  onCancel,
  onConfirm
}) => {
  const { t } = useTranslation()
  const [comment, setComment] = useState('')
  const [showDetails, setShowDetails] = useState(false)

  useEffect(() => {
    if (open) {
      setComment('')
      setShowDetails(false)
    }
  }, [open])

  const handleConfirm = () => onConfirm(comment.trim())

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      title={
        count > 1
          ? t('icReconciliation:approveTitlePlural', 'Merkitse {{count}} riviä hyväksytyksi', { count })
          : t('icReconciliation:approveTitle', 'Merkitse rivi hyväksytyksi')
      }
    >
      <Text type="secondary">
        {t(
          'icReconciliation:approveDescription',
          'Lisää perustelu hyväksymiselle. Tieto tallentuu hyväksyjän ja ajankohdan kanssa.'
        )}
      </Text>{' '}
      <Button
        type="link"
        size="small"
        onClick={() => setShowDetails(value => !value)}
        style={{ padding: 0, height: 'auto', fontSize: 12 }}
      >
        {showDetails
          ? t('icReconciliation:approveDescriptionCollapse', 'Näytä vähemmän')
          : t('icReconciliation:approveDescriptionExpand', 'Näytä lisää')}
      </Button>
      {showDetails && (
        <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>
          {t(
            'icReconciliation:approveDescriptionDetails',
            'Hyväksytty rivi siirtyy pois avoimista ja näkyy Hyväksytyt-näkymässä. Hyväksyminen ei muuta rivin luokituksia eikä kirjanpitoa; jos summat, päivät tai tilit muuttuvat, hyväksyntä vanhenee ja rivi palaa käsiteltäväksi. Voit perua hyväksynnän milloin tahansa.'
          )}
        </Text>
      )}
      <TextArea
        style={{ marginTop: 12 }}
        rows={3}
        value={comment}
        onChange={event => setComment(event.target.value)}
        placeholder={t('icReconciliation:approvePlaceholder', 'Esim. valuuttakurssin pyöristysero...')}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
        <Button onClick={onCancel}>{t('icReconciliation:approveCancel', 'Peruuta')}</Button>
        <Button type="primary" loading={loading} onClick={handleConfirm}>
          {t('icReconciliation:approveConfirm', 'Hyväksy')}
        </Button>
      </div>
    </Modal>
  )
}

export default ReconciliationApproveModal
